import { render, staticRenderFns } from "./MtipocanalcmncForm.vue?vue&type=template&id=7defda25"
import script from "./MtipocanalcmncForm.vue?vue&type=script&lang=js"
export * from "./MtipocanalcmncForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports